module.exports = __webpack_public_path__ + "img/Hero.f81e0c6f.svg";